import { useQuery } from '@tanstack/react-query';
import { MdError } from 'react-icons/md';
import { toast } from 'react-toastify';
import ReactIcon from '../components/ReactIcon';
import { getErrorMessageExact } from '../helpers/errorMessages';
import authenticationService from '../services/authentication.service';
import { useToken } from '../store/auth/tokenStore';
import {
    getValidProductGiftsInCart,
    useShoppingCartStore,
} from '@/store/shoppingCart/shoppingCartStore';
import { useEffect } from 'react';

export const useUserProfile = () => {
    const { token } = useToken.getState();

    const { isPending, data } = useQuery({
        queryKey: ['MyProfile'],
        queryFn: async () => {
            const { error, profile } =
                await authenticationService.fetchMyProfile();

            if (error) throw new Error(error);

            return profile!;
        },
        throwOnError: error => {
            const errorMessage = getErrorMessageExact(error.message);

            if (!token) return false;

            toast.warn(() => errorMessage || 'Erro ao carregar sua conta', {
                toastId: 5,
                style: {
                    fontSize: '1rem',
                    fontWeight: '400',
                },
                position: 'top-right',
                autoClose: 5000,
                icon: (
                    <ReactIcon
                        Icon={MdError}
                        size={'1.5rem'}
                        fill="#e40505"
                        color="white"
                    />
                ),
            });
            return false;
        },
        enabled: Boolean(token),
    });

    useEffect(() => {

        const newCartProducts = getValidProductGiftsInCart(data);
        useShoppingCartStore.getState().setCartProducts(newCartProducts);
    }, [data, token]);

    return {
        isPending,
        data,
    };
};
